// Who owns the session lifecycle.
//
// Normally the app owns it: it signs out when the tab is hidden, prompts for re-auth on idle, and
// hard-signs-out on the panic detectors. That is correct when the app is the top-level owner of a
// short-lived session.
//
// When the app runs embedded in a host that owns the session lifecycle itself, the app must NOT
// self-manage it — the host does. Two such hosts:
//   - the auth-domain iframe (window.In6to.isAuth): only a login surface, never a full session;
//   - a native browser that holds the session and drives its own re-auth and wipe
//     (window.In6to.hosted), set by that browser before this bundle runs.
//
// Use this ONLY to gate session-lifecycle self-management (leave-signout, idle re-auth, panic
// signout). Do NOT use it to gate data loading — an embedded-but-hosted app still loads chats etc.;
// those checks stay on window.In6to.isAuth alone.
//
// SECURITY: window.In6to.hosted disables the app's own session self-protection, so only a trusted
// native host may set it. Ordinary web content cannot (a page cannot write another origin's
// globals); the marker is injected by the hosting browser engine, and the server stays the backstop
// on session lifetime and re-auth so a forged marker cannot, by itself, outlive server policy. See
// the safe-browser spec (in6to-auto-login) for how the host proves itself.
export const hostManagesSession = () => window.In6to.isAuth || window.In6to.hosted;
